import { connect } from "react-redux";
import { isCurrentlyViewedClient } from "../../../../modules/activity";
import ActivityEmail from "../ActivityEmail";

function select({ user, activities, listings }, { activityId }) {
  const activity = activities.byId[activityId] || {};
  const stream = activity.stream || {};
  const streamItemIds = stream.streamItemIds || [];
  const streamItem = activity.streamItem || {};
  const streamItemId = streamItem.id || streamItemIds[0] || "";
  const listingIds = stream.listingIds || [];
  const firstListing = listings.byId[listingIds[0] || ""] || {};
  const client = activity.client || {};

  return {
    activityId: activity.id || "",
    streamId: stream.id || "",
    streamTitle: stream.title || "",
    streamItemId,
    hasStreamItemId: !!streamItemId,
    clientId: client.id || "",
    clientName: client.name || "",
    listingAddress: firstListing.addressFormatted || "",
    listingId: firstListing.id || "",
    streamItemCount: streamItemIds.length,
    hasMultipleStreamItems: streamItemIds.length > 1,
    isAgent: user.isAgent || false,
    isCommenter: user.isClient && user.id === activity.client.id,
    isCurrentlyViewedClient: isCurrentlyViewedClient(activity)
  };
}

export default connect(select)(ActivityEmail);
